import api from './client';

export const crmApi = {
  enquiries:     (params?: any) => api.get('/crm/enquiries', { params }),
  createEnquiry: (data: any)    => api.post('/crm/enquiries', data),
  getEnquiry:    (id: number)   => api.get(`/crm/enquiries/${id}`),
  updateEnquiry: (id: number, data: any) => api.put(`/crm/enquiries/${id}`, data),
  followUp:      (data: any)    => api.post('/crm/follow-ups', data),
  due:           ()             => api.get('/crm/due'),
  accounts:      (params?: any) => api.get('/crm/accounts', { params }),
  getAccount:    (id: number)   => api.get(`/crm/accounts/${id}`),
  updateAccount: (id: number, data: any) => api.put(`/crm/accounts/${id}`, data),
  addPerson:     (data: any)    => api.post('/crm/people', data),
  removePerson:  (id: number)   => api.delete(`/crm/people/${id}`),
};
